export default function comma(num) {
  if (num != null) {
    const str = String(num);
    const parts = str.split('.');

    // 整数部分に3桁区切りカンマを追加
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

    // 小数部分がある場合は結合、ない場合は整数部分のみ
    return parts.length > 1 ? parts.join('.') : parts[0];
  }
  return num;
}
